module.exports = __webpack_public_path__ + "img/arr-r.672d3eba.svg";